import React, { useState } from 'react';
import { useHistory } from 'react-router';

import Button from '@material-ui/core/Button/Button';
import { CircularProgress } from '@material-ui/core';

import logo from '../../assets/img/logo-full.png';
import '../../assets/css/login.css';

import { useDispatch, useSelector } from 'react-redux';
import * as authActions from '../../store/actions/authActions';
import { Link } from 'react-router-dom';
import { Fragment } from 'react';
import AlertError from './AlertError';
 
const Login = () => {
    const initialUserValues = { email: '', password: '' };
    const [user, setUser] = useState(initialUserValues);
    const [isLoading, SetIsLoading] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const dispatch = useDispatch();

    const history = useHistory();

    const handleSubmit = async (e) => {
        e.preventDefault();
        SetIsLoading(true);
        dispatch(authActions.authLogin(user))
            .then(() => {
                history.push('/loadprofile');
            })
            .catch(() => {
                SetIsLoading(false);
                setShowError(true);
                setErrorMessage('Incorrect log in credentials');
            });
    };

    const renderButtons = () => {
        return (
            <Fragment>
                <button name="login" id="login" className="welcome-btn" type="submit">Log In</button>
            </Fragment>
        );
    }

    return (
        <div className="main-container">
            <div className="welcome-container">
                <img className="welcome-logo" src={logo} />
                <h2 className="welcome-title">Welcome Back</h2>

                <div className="welcome-form">
                    {showError ? <AlertError message={errorMessage} /> : null}

                    <form onSubmit={handleSubmit}>
                        <input 
                            type="email" 
                            name="email"
                            id="email" 
                            className="welcome-field" 
                            placeholder="Email Address"
                            onChange={e => setUser({...user, email: e.target.value})} />
                        <input 
                            type="password" 
                            name="password" 
                            id="password" 
                            className="welcome-field" 
                            placeholder="Password"
                            onChange={e => setUser({...user,password: e.target.value})} />
                        <Link to="/account/forgotpassword" className="forgot-btn">Forgot Password?</Link>
                        
                        {isLoading ? <CircularProgress /> : renderButtons()}
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Login;